import { useNotification } from "providers"
import { handleRequest } from "utils";
import { IDeleteUserRequest, IGetAdminUserStatusStatsResponse, IGetNotificationCountRequest, IGetUserRequest, IGetUsersRequest, IGetUsersResponse, IGetUserStatusStatsResponse, IMeResponse, IUpdateUserRequest } from "./types";
import { ApiResponse, ISiteContact, IUser } from "utils/types";
import { useUserService } from "./service";

export const useUser = () => {
    const notification = useNotification();
    const service = useUserService();
    const request:typeof handleRequest = (fun, input) => {
        return handleRequest(fun, input, notification)
    }
    return {
        contactUse(input: Partial<ISiteContact>){
            return request(
                async (input: Partial<ISiteContact>): Promise<ApiResponse<boolean>> => {
                try {
                    const { data, errors } = await service.createContactUs({
                        variables: {
                            contactMessage: input
                        }
                    });
                    if(errors?.length){
                        throw new Error(errors[0].message)
                    }
                    return {
                        success: true,
                        data: true
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, input)
        },
        me(){
            return request(
                async (): Promise<ApiResponse<IMeResponse>> => {
                try {
                    const { data, error } = await service.me();
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.me,
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, null)
        },
        getUserStatusStats(){
            return request(
                async (): Promise<ApiResponse<IGetUserStatusStatsResponse>> => {
                try {
                    const { data, error } = await service.getUserStatusStats({
                        fetchPolicy: "network-only"
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getUserStatusStats
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, null)
        },
        getAdminUserStatusStats(){
            return request(
                async (): Promise<ApiResponse<IGetAdminUserStatusStatsResponse>> => {
                try {
                    const { data, error } = await service.getAdminUserStatusStats({
                        fetchPolicy: "network-only"
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getAdminUserStatusStats
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, null)
        },
        getUsers(input: IGetUsersRequest){
            return request(
                async (input: IGetUsersRequest): Promise<ApiResponse<IGetUsersResponse>> => {
                try {
                    const { data, error } = await service.getUsers({
                        variables: input
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getUsers
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, input)
        },
        getUser(input: IGetUserRequest){
            return request(
                async (input: IGetUserRequest): Promise<ApiResponse<IUser>> => {
                try {
                    const { data, error } = await service.getUser({
                        variables: input
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getUser.user,
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, input)
        },
        updateUser(input: IUpdateUserRequest){
            return request(
                async (input: IUpdateUserRequest): Promise<ApiResponse<IUser>> => {
                try {
                    const { data, errors } = await service.updateUser({
                        variables: input
                    });
                    if(errors){
                        throw new Error(errors[0].message)
                    }
                    return {
                        success: true,
                        data: data?.updateUser.user,
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, input)
        },
        deleteUser(input: IDeleteUserRequest){
            return request(
                async (input: IDeleteUserRequest): Promise<ApiResponse<string>> => {
                try {
                    const { data, errors } = await service.deleteUser({
                        variables: input
                    });
                    if(errors){
                        throw new Error(errors[0].message)
                    }
                    return {
                        success: true,
                        data: data?.deleteUser.userId,
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                    }
                }
            }, input)
        },
        getNotificationCount(input: IGetNotificationCountRequest){
            return request(
                async (input: IGetNotificationCountRequest): Promise<ApiResponse<number>> => {
                try {
                    const { data, error } = await service.getNotificationCount({
                        variables: input
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getNotificationCount.count || 0,
                    }
                } catch (e) {
                    return {
                        err: (e as Error),
                        data: 0
                    }
                }
            }, input)
        },
        /* getNotifications(input: IGetNotificationsRequest){
            return request(
                async (input: IGetNotificationsRequest): Promise<ApiResponse<INotification[]>> => {
                try {
                    const { data, error } = await service.getNotifications({
                        variables: input
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getNotifications.notifications,
                    }
                } catch (e) {
                    return {
                        err: (e as Error)
                    }
                }
            }, input)
        },
        getNotification(input: IGetNotificationRequest){
            return request(
                async (input: IGetNotificationRequest): Promise<ApiResponse<INotification>> => {
                try {
                    const { data, error } = await service.getNotification({
                        variables: input
                    });
                    if(error){
                        throw new Error(error.message)
                    }
                    return {
                        success: true,
                        data: data?.getNotification.notification,
                    }
                } catch (e) {
                    return {
                        err: (e as Error)
                    }
                }
            }, input)
        }, */
    }
}